module.exports = __webpack_public_path__ + "static/media/homepage_build_hero_section.94cddbae.png";